export const priceDisplayType = {
  display: "表示",
  hide: "非表示",
};
